import React from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Info } from "lucide-react";

interface RevenueTooltipProps {
  children: React.ReactNode;
  title: string;
  calculation: Array<{
    label: string;
    value: number;
    isTotal?: boolean;
    isSubtraction?: boolean;
    isAddition?: boolean;
  }>;
}

export const RevenueTooltip: React.FC<RevenueTooltipProps> = ({
  children,
  title,
  calculation
}) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-NZ', {
      style: 'currency',
      currency: 'NZD',
      minimumFractionDigits: 2
    }).format(amount);
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="cursor-help">
            {children}
          </div>
        </TooltipTrigger>
        <TooltipContent className="max-w-md">
          <div className="space-y-3">
            <h4 className="font-semibold text-sm">{title}</h4>
            <div className="space-y-2 text-xs">
              {calculation.map((item, index) => (
                <div
                  key={index}
                  className={`flex justify-between items-center gap-4 ${
                    item.isTotal ? 'font-semibold border-t pt-1 mt-2' : ''
                  }`}
                >
                  <span className="flex items-center gap-1 pr-2">
                    {item.isSubtraction && <span className="text-red-500">−</span>}
                    {item.isAddition && <span className="text-green-500">+</span>}
                    {item.label}
                  </span>
                  <span className={`${item.isTotal ? 'font-bold' : ''} whitespace-nowrap`}>
                    {formatCurrency(item.value)}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};